import { Module } from "../../Model/Module";
import { ModuleState, EInstrumentType, EImagingModuleStatus } from "../../Model/ModuleState";
import ImagerUtil from "../../Utility/ImagerUtil";
import React, { useState } from "react";

export type ImagerStatusComponentProps = {
  instrumentType: EInstrumentType;
  imagerModule: Module;
  moduleStateById: { [index: string]: ModuleState };
};

export default function ImagerStatusComponent({
  instrumentType,
  imagerModule,
  moduleStateById,
}: ImagerStatusComponentProps) {
  const moduleState = moduleStateById[imagerModule.identifier];
  const imagerState = moduleState.imager;

  if (imagerState == null) {
    throw new Error("Imager State is null");
  }

  const requiredSpace =
    imagerState?.resourceStatus?.driveSpace?.requiredAdditionalFreeSpaceInByte;
  const requiredSpaceSpaceInGb =
    (requiredSpace / (1024 * 1024 * 1024)).toFixed(2) + " GB";

  const requiredMemory =
    imagerState?.resourceStatus?.memory?.requiredAdditionalFreeMemoryInByte ??
    0;
  const requiredMemoryInMb =
    (requiredMemory / (1024 * 1024)).toFixed(2) + " MB";

  const isWaitingForStorage =
    !imagerState?.resourceStatus?.driveSpace?.isAvailable ?? false;
  const isWaitingForMemory =
    !imagerState?.resourceStatus?.memory?.isAvailable ?? false;

  let status = imagerState.status;
  if (isWaitingForMemory && !isWaitingForStorage) {
    status = `Waiting for ${requiredMemoryInMb} of Memory`;
  }
  if (isWaitingForStorage && !isWaitingForMemory) {
    status = `Waiting for ${requiredSpaceSpaceInGb} of Disk Space`;
  }

  if (isWaitingForStorage && isWaitingForMemory) {
    status = `Waiting for ${requiredMemoryInMb} of Memory and ${requiredSpaceSpaceInGb} of Disk Space`;
  }

  if(imagerState?.isImagingArmMoving && imagerState.state === EImagingModuleStatus.Idle){
    status = "Testing";
  }

  return (
    <div
      style={{
        height: "72px",
        minWidth: "250px",
        display: "flex",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
        key={"imager-status-1"}
      >
        <div className="status-item" style={{ minWidth: 160 }}>
          <div>{`${imagerModule.name}:`}</div>
          <div
            style={{
              color: "green",
              marginLeft: 2,
            }}
          >
            {status}
          </div>
        </div>
        {instrumentType == EInstrumentType.RI360 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
            key={"imager-status-2"}
          >
            <div className="status-item">
              <div>
                X:{" "}
                <span style={{ color: "green" }}>
                  {imagerState.imagingArmPosition.x.toFixed(2) + " "}
                </span>
                Y:{" "}
                <span style={{ color: "green" }}>
                  {imagerState.imagingArmPosition.y.toFixed(2) + " "}
                </span>
                Z:{" "}
                <span style={{ color: "green" }}>
                  {imagerState.imagingArmPosition.z.toFixed(2) + " "}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
